import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../../shared/base-api-template-service.model';
import { Core2Config } from '../../../shared/core2Config';
import { ApiResponseModel, ApiVisa, Pagination, PagingResponseModel, BasicApiResponseModel } from '../../../shared';
import { PackingDto, PickingQueueDto } from '../../../../data-transfer-objects';
import { MrpPickPackQueueContainerModel } from '../../../../../../../models/aggregates/erp/delivery/pick-pack-queue/mrp-pick-pack-queue-container.model';
import { MrpPickPackQueueOutputContainerModel } from '../../../../../../../models/aggregates/erp/delivery/pick-pack-queue/mrp-pick-pack-queue-output-container.model';

@Injectable({ providedIn: 'root' })
export class MrpPickPackQueueService extends BaseApiTemplateService<MrpPickPackQueueContainerModel> {
  endpoint_path_base = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MRP_PREFIX + "mrp-pick-pack-queues";

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + this.endpoint_path_base + "/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = this.endpoint_path_base + "/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }

  /** The MRP Pick Pack queue is connected to the Financial Pick Pack Queue. Please ensure to post to the Financial Pick Pack Queue before posting to the Mrp Pick Pack Queue */
  public insertToMrpPickingQueue(payload: PickingQueueDto, visa: ApiVisa) {
    let url = this.endpoint_path;
    if (this.endpoint_path_base && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path_base + "/insert-mrp-picking-queue/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    }
    return this.httpClient.post<ApiResponseModel<MrpPickPackQueueContainerModel>>(url, payload, this.getHttpHeader(visa));
  }

  public getOutstandingByCriteria(criteria: Pagination, visa: ApiVisa) {
    let url = this.endpoint_path;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + "/get-outstandings/query?" + criteria.getQueryKeyValues();
    }
    return this.httpClient.post<PagingResponseModel<MrpPickPackQueueOutputContainerModel>>(url, criteria, this.getHttpHeader(visa));
  }

  public updateBalanceAwaitingApproval(payload: PackingDto, visa: ApiVisa) {
    let url = this.endpoint_path;
    if (this.endpoint_path_base && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path_base + "/update-balance-awaiting-approval/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    }
    return this.httpClient.put<BasicApiResponseModel<MrpPickPackQueueContainerModel>>(url, payload, this.getHttpHeader(visa));
  }

  public updateQtyBalance(payload: PackingDto, visa: ApiVisa) {
    let url = this.endpoint_path;
    if (this.endpoint_path_base && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path_base + "/update-qty-balance/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    }
    return this.httpClient.put<BasicApiResponseModel<MrpPickPackQueueContainerModel>>(url, payload, this.getHttpHeader(visa));
  }
}